const headers: { [k: string]: string } = {};

if (process.env.npm_package_name != null && process.env.npm_package_version != null) {
  headers['X-Avalara-Client'] = `${process.env.npm_package_name} ; ${process.env.npm_package_version}`;
}

export default headers;
